import React from "react";
import { Loader } from "@design-system/Loader/Loader";
import {
    StandardModal,
    StandardModalBody,
    StandardModalHeader,
} from "@design-system/Modal/Modal";
interface Props {
    show: boolean;
}

export const NewConnectionLoaderModal: React.FC<Props> = ({ show }) => (
    <StandardModal
        show={show}
        size="lg"
        backdrop="static"
        dialogClassName="accounts-connected-modal__dialog"
    >
        <>
            <StandardModalHeader>Loading accounts</StandardModalHeader>
            <StandardModalBody>
                <p>This might take a few seconds...</p>

                <div className="py-5">
                    <Loader />
                </div>
            </StandardModalBody>
        </>
    </StandardModal>
);
